import Button, { ButtonTypes } from "@/components/button/Button"
import { useAuth } from "@/components/context/AuthProvider"
import { useGeneralContext } from "@/components/context/GeneralContext"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { createdProjectId } from "@/helpers/globalVariables"
import { EASETECH } from "@/utilities/global-variables"
import { Tooltip } from "antd"
import { FC } from "react"
import { useNavigate } from "react-router"
import { useLocalStorage } from "react-use"

type Props = {
  buttonType?: ButtonTypes
  tooltipText?: string
  size?: "small" | "middle" | "large"
  block?: boolean
  onClick?: () => void
  loading?: boolean
}

const CreateApplicationButton: FC<Props> = ({
  buttonType = "primary",
  tooltipText,
  size = "middle",
  block,
  onClick,
  loading = false,
}) => {
  const { setCurrentLevelOfService, setCurrentCompanyId } = useGeneralContext()
  const { openDarkModal } = useModalDarkContext()
  const navigate = useNavigate()

  const [, setProjectId] = useLocalStorage<string>(createdProjectId)
  const { organization, user } = useAuth()
  const currentLicenseType = user?.userProfile?.data?.attributes?.licenseType

  const handleCreateApplication = () => {
    if (onClick) {
      onClick()
    }
    setCurrentCompanyId(null) // To not interfere with other flow
    if (organization === EASETECH) {
      openDarkModal({
        type: currentLicenseType === "free" ? "single-submission" : "level-of-service",
        isLogo: true,
        mode: "default",
        width: "width900",
      })
      setProjectId("")
    } else {
      setCurrentLevelOfService(null) // Not applying any filters for the rest of users
      navigate(`/${organization}/dashboard/create-project/details`)
      setProjectId("")
    }
  }

  return (
    <Tooltip overlayClassName={"main-tooltip"} placement={"bottomRight"} title={tooltipText ?? ""}>
      <Button
        btnType={buttonType}
        text={"Create Application"}
        onClick={handleCreateApplication}
        size={size}
        block={block}
        loading={loading}
      />
    </Tooltip>
  )
}

export default CreateApplicationButton
